import { FaTrash, FaRegTimesCircle } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import L from 'leaflet';
import '../styles/global.css';
import { useEffect, useRef, useState } from 'react';
import API, { API_URL } from '../api/API';
import { carregarZipFromURL, createMapOnBahia, popUpForPropriedade } from '../utils/mapas';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import CustomToolbar from './components/CustomToolbar';
import { Toast } from 'primereact/toast';
import * as mapas from '../utils/mapas'
import { ImovelType, LoteType, MunicipioType, newImovel, PropriedadeSearchType } from '../db/Orm';
import { Dock } from 'primereact/dock';
import { MenuItem } from 'primereact/menuitem';
import { ReactComponent as BackIcon } from '../images/back.svg';
import { ReactComponent as AlgodaoIcon } from '../images/algodao.svg';
import { ReactComponent as ListIcon } from '../images/book-library-svgrepo-com.svg';
import { ReactComponent as DownloadIcon } from '../images/download.svg';

import { ReactComponent as SojaIcon } from '../images/soja.svg';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressBar } from 'primereact/progressbar';
import { Calendar } from 'primereact/calendar';
import { AxiosError } from 'axios';
import { Tooltip } from 'primereact/tooltip';
import Auth from '../auth/Authenticator';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from 'primereact/radiobutton';

enum ProcessMethodType {
    RegressaoLinear = 'rl',
    RedeNeural = 'rn'
}

function Propriedade() {
    const mapRef = useRef<any>(null);
    const auth = Auth.useAuth();
    // const [user, propriedade, municipios] = useLocation().state as any;
    const [propSearch, municipio] = useLocation().state as [PropriedadeSearchType, MunicipioType];
    const navigator = useNavigate();
    const [mapa, setMapa] = useState<L.Map>();
    const toast = useRef<Toast | null>(null)
    const [downloadDialogVisible, setDownloadDialogVisible] = useState(false);
    const [propriedade, setPropriedade] = useState<ImovelType>(newImovel())
    
    useEffect(() => {
        if (typeof(propSearch?.id) !== 'number') return
        API.getData(`${API_URL}propriedades/${propSearch.id}/`, navigator, console.error).then((data) => {
            if (data) setPropriedade(data)
            console.log(data)
        });
    }, [propSearch.id]);


    useEffect(() => {
        try {
            !mapa && setMapa(createMapOnBahia(mapRef))
        } catch (e: any) {
            console.log('error:', e)
        }
    }, []);

    const [loading, setLoading] = useState(false)

    const loadFazenda = async () => {
        if (mapa) {
            if (propriedade.poligono) {
                const poligonos = await carregarZipFromURL(propriedade.poligono, mapas.estiloContorno)
                poligonos.eachLayer(poligono => {
                    if (poligono instanceof L.FeatureGroup) {
                        poligono.bindPopup(popUpForPropriedade(propriedade, poligono))
                        mapa.addLayer(poligono);
                        poligono.openPopup()
                    }
                    mapa.flyToBounds(poligonos.getBounds())
                })
            }
            propriedade.lotes?.map(async (lote: LoteType) => {
                const polygon = await carregarZipFromURL(lote.poligono, mapas.estiloArea)
                mapa.addLayer(polygon)
            })
        }
    }
    useEffect(() => {
        loadFazenda()
    }, [mapa, propriedade.poligono]);

    const confirmRemove = () => {
        if (!auth.hasPermission('monitorabahia.delete_propriedade')) {
            toast.current?.show({ severity: 'error', summary: 'Permissões Insuficientes', detail: 'Você não possui permissão para remover propriedade.' })
            return
        }
        confirmDialog({
            message: 'Você tem certeza que deseja remover a propriedade ' + propriedade.nome + '?',
            header: 'Cadastro de Propriedade',
            icon: 'pi pi-exclamation-triangle',
            accept,
            reject
        });
    }

    const accept = async () => {
        await API.removePropriedade(propriedade, toast.current)
        navigator('/municipio', { state: [municipio] })
    }

    const reject = () => {
    }

    const [dialogVisivel, setDialogVisivel] = useState(false);
    const [progresso, setProgresso] = useState(0);
    const [mensagemLoading, setMensagemLoading] = useState('');
    const [apiConcluida, setApiConcluida] = useState(false); // Controla se a chamada da API (sucesso/erro) terminou
    const toastRef = useRef<any>(null);
    const [dialogProcessarVisivel, setDialogProcessarVisivel] = useState(false)
    const [dialogCheckVisivel, setDialogCheckVisivel] = useState<boolean>(false)
    const [mensagemCheck, setMensagemCheck] = useState<string>('')
    // const [dataInicio, setDataInicio] = useState<Nullable<Date>>(null)
    // const [dataFinal, setDataFinal] = useState<Nullable<Date>>(null)
    const [erroProcessar, setErroProcessar] = useState<Boolean>(false)
    const [segundos, setSegundos] = useState(0);

    const intervaloProgressoRef = useRef<any>(null);
    const segundosIntervalRef = useRef<any>(null);
    const segundosRef = useRef(0);
    const inicioTimerRef = useRef<any>(null);
    const filenameRef = useRef<string>()
    const CINCO_MINUTOS_MS = 2 * 60 * 1000;
    const [processType, setProcessType] = useState<string>('soja')
    const [processMethod, setProcessMethod] = useState<ProcessMethodType>(ProcessMethodType.RegressaoLinear)
    // Limpa o intervalo quando o componente é desmontado
    useEffect(() => {
        return () => {
            if (intervaloProgressoRef.current) {
                clearInterval(intervaloProgressoRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (dialogVisivel) {
            segundosIntervalRef.current = setInterval(() => {
                segundosRef.current += 1;
                setSegundos(segundosRef.current);
            }, 1000);
        } else if (segundosIntervalRef.current) {
            clearInterval(segundosIntervalRef.current);
            segundosIntervalRef.current = null;
        }

        return () => {
            if (segundosIntervalRef.current) {
                clearInterval(segundosIntervalRef.current);
            }
        };
    }, [dialogVisivel]);

    const processar = async () => {
        if (!dates[0] || !dates[1]) return
        setDialogProcessarVisivel(false)
        setErroProcessar(false)
        setDialogVisivel(true);
        segundosRef.current = 0;
        setSegundos(0);
        setProgresso(0);
        setApiConcluida(false);
        setMensagemLoading('Iniciando processamento do relatório...');
        inicioTimerRef.current = Date.now();

        // Limpa qualquer intervalo anterior
        if (intervaloProgressoRef.current) {
            clearInterval(intervaloProgressoRef.current);
        }

        // Configura o intervalo para a barra de progresso atingir 100% em 5 minutos
        intervaloProgressoRef.current = setInterval(() => {
            const tempoDecorrido = Date.now() - inicioTimerRef.current;
            const progressoAtual = Math.round(Math.min(100, (tempoDecorrido / CINCO_MINUTOS_MS) * 100));
            setProgresso(progressoAtual);

            if (progressoAtual >= 100) {
                clearInterval(intervaloProgressoRef.current);
                intervaloProgressoRef.current = null;
                // Se a API ainda não terminou, a mensagem pode mudar
                if (!apiConcluida) {
                    setMensagemLoading('O processamento está quase lá. Apenas mais alguns instantes...');
                }
            }
        }, 200); // Atualiza a cada 200ms para uma animação suave

        try {
            // Chamada real da API
            const response = processType === 'soja' ?
                await API.processarSojaPropriedade(propriedade.id, dates[0], dates[1], processMethod) :
                await API.processarAlgodaoPropriedade(propriedade.id, dates[0], dates[1], processMethod);
            if ('toJSON' in response) { //Ocorreu erro
                throw response
            }
            setApiConcluida(true); // API terminou (com sucesso)

            if (intervaloProgressoRef.current) { // Para o timer da barra de progresso se ainda estiver rodando
                clearInterval(intervaloProgressoRef.current);
                intervaloProgressoRef.current = null;
            }
            if (segundosIntervalRef.current) {
                clearInterval(segundosIntervalRef.current);
                segundosIntervalRef.current = null;
            }
            setProgresso(100); // Garante que a barra está em 100%
            setMensagemLoading('Relatório processado com sucesso! Preparando para download...');

            // Lógica de download do arquivo (adaptada da sua implementação anterior)
            if (response !== null) {
                const blob = response.data as Blob;
                let filename = `relatorio_${propriedade.nome || propriedade.id}.pdf`; // Nome de fallback
                const contentDisposition = response.headers['content-disposition'];
                console.log('response.headers', response.headers)
                if (contentDisposition) { //PDF foi gerado
                    const filenameMatch = contentDisposition.match(/filename="?(.+?)"?(;|$)/i);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1];
                    }
                    downloadBlobResponse(blob, filename, segundosRef.current)
                } else {
                    const data = JSON.parse(await blob.text())
                    setMensagemCheck(data.detail)
                    setDialogCheckVisivel(true)
                    filenameRef.current = data.filename
                }
                setTimeout(() => setDialogVisivel(false), 1500); // Fecha o diálogo após um tempo
            }

        } catch (error: any) {
            const axiosErr = error as AxiosError
            const blobResp = axiosErr.response?.data as Blob
            const jsonResp = blobResp ? JSON.parse(await blobResp.text()) : null
            setApiConcluida(true); // API terminou (com erro)
            if (intervaloProgressoRef.current) {
                clearInterval(intervaloProgressoRef.current);
                intervaloProgressoRef.current = null;
            }
            console.error('Erro ao processar relatório:', error);
            jsonResp && console.error(jsonResp)
            setErroProcessar(true)
            let mensagemErroApi = 'Falha ao processar o relatório: ';
            mensagemErroApi += error.message ? error.message : 'Não foi possível ler a mensagem de erro do servidor.'
            jsonResp && (mensagemErroApi += (mensagemErroApi.endsWith('.') || '. ') + jsonResp.detail)
            console.log(mensagemErroApi)
            setMensagemLoading(mensagemErroApi)
            setDialogVisivel(false)
            toastRef.current.show({ severity: 'error', summary: 'Erro no Processamento', detail: mensagemErroApi, life: 6000 });
        }
    };
    const downloadBlobResponse = (blob: Blob, filename: string, tempo: number) => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        toastRef.current.show({ severity: 'success', summary: 'Sucesso', detail: `Download do '${filename}' iniciado. O processamento levou ${tempo} segundos.`, life: 5000 });
    }
    const onHideDialog = () => {
        setDialogVisivel(false);
        // Resetar estados para a próxima vez, se necessário,
        // especialmente se o usuário puder fechar manualmente (o que não é o caso aqui durante o processamento)
        if (apiConcluida) {
            setProgresso(0);
            setMensagemLoading('');
        }
    };

    const [showInfo, setShowInfo] = useState<boolean>(false)
    const InfoMenu = {
        label: 'Pesquisar',
        icon: () => <ListIcon />,
        command: () => { setShowInfo(true) }
    }
    const SojaMenu = {
        label: 'Processar Soja',
        icon: <SojaIcon />,
        command: () => { setProcessType('soja'); setDialogProcessarVisivel(true) }
    }
    const AlgodaoMenu = {
        label: 'Processar Algodão',
        icon: <AlgodaoIcon />,
        command: () => { setProcessType('algodao'); setDialogProcessarVisivel(true) }
    }
    const DownloadMenu = {
        label: 'Download',
        icon: () => <DownloadIcon />,
        command: () => { setDownloadDialogVisible(true) }
    }
    const VoltarMenu = {
        label: 'Voltar',
        icon: () => <BackIcon />,
        command: () => {
            console.log('Fazenda', propriedade)
            navigator('/municipio', { state: [municipio] })
        }
    }
    const items: MenuItem[] = (() => {
        if (!auth.user) return [VoltarMenu]
        const options = []
        if (auth.hasPermission('monitorabahia.propriedades_info')) options.push(InfoMenu)
        if (auth.hasPermission('monitorabahia.propriedades_processar')) options.push(SojaMenu)
        if (auth.hasPermission('monitorabahia.propriedades_processar')) options.push(AlgodaoMenu)
        if (auth.hasPermission('monitorabahia.propriedades_info')) options.push(DownloadMenu)
        options.push(VoltarMenu)
        return options
    })()

    const dialogFooter = apiConcluida ? (
        <Button label="Fechar" icon="pi pi-check" onClick={onHideDialog} autoFocus />
    ) : null;
    const [dates, setDates] = useState<Date[]>([])
    const minDate = new Date()
    minDate.setFullYear(minDate.getFullYear() - 5)
    const maxDate = new Date()
    const handleUpdateDates = (e: any) => {
        const dates: (Date | null)[] = e.value
        setDates(dates.filter(d => d !== null) as Date[])
    }

    const dialogProcessarHeader = <div style={{ display: 'flex', alignItems: 'center', height: 10 }}>
            {processType === 'soja' ? <SojaIcon width={32} style={{ marginRight: 10 }} /> : <AlgodaoIcon width={32} style={{ marginRight: 10 }} />}PROCESSAR {processType === 'soja' ? 'SOJA' : 'ALGODÃO'} PROPRIEDADE
        </div>

    const dialogProcessar = <Dialog onHide={() => { setDialogProcessarVisivel(false) }} visible={dialogProcessarVisivel}
    header={dialogProcessarHeader}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
            <label style={{ marginLeft: 15 }}>Período</label>
            <Calendar style={{ marginLeft: 10, width: 850 }}
                dateFormat='dd/mm/yy' onChange={handleUpdateDates} value={dates}
                // showIcon 
                minDate={minDate} maxDate={maxDate}
                selectionMode="range" readOnlyInput hideOnRangeSelection numberOfMonths={2} inline />
        </div>
        <Fieldset legend='Método' style={{marginTop: '1rem'}}>
            <span>EM DESENVOLVIMENTO</span>
            <RadioButton inputId="rl" name="processMethod" value={ProcessMethodType.RegressaoLinear} onChange={(e) => setProcessMethod(e.value)} checked={processMethod === ProcessMethodType.RegressaoLinear} />
            <label htmlFor="rl" style={{ marginLeft:'0.5rem', marginRight: '2rem' }}>Regressão Linear</label>
            <RadioButton inputId="rn" name="processMethod" value={ProcessMethodType.RedeNeural} onChange={(e) => setProcessMethod(e.value)} checked={processMethod === ProcessMethodType.RedeNeural} />
            <label htmlFor="rn" style={{ marginLeft:'0.5rem', marginRight: '2rem' }}>Rede Neural</label>
        </Fieldset>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
            <Button onClick={() => processar()}>INICIAR</Button>
        </div>
    </Dialog>

    const handleDownload = (type: 'propriedade' | 'lotes', format: 'shp' | 'kml') => {
        // const baseUrl = 'https://api.monitorabahia.gearspark.com.br/api';
        const baseUrl = API_URL;
        const endpoint = type === 'propriedade' ? 'download_poligono' : 'download_lotes';
        const url = `${baseUrl}propriedades/${propriedade.id}/${endpoint}/?tipo=${format}`;

        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setDownloadDialogVisible(false);
        toast.current?.show({ severity: 'success', summary: 'Download Iniciado', detail: `O download do arquivo ${format.toUpperCase()} foi iniciado.`, life: 3000 });
    };

    const downloadDialog = (
        <Dialog header="Download de Arquivos" visible={downloadDialogVisible} style={{ width: '30vw' }} onHide={() => setDownloadDialogVisible(false)}>
            <div className="p-fluid">
                <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', justifyContent: 'center', marginBottom: '1rem', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <h4>Propriedade</h4>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', height: 100, marginRight:10 }}>
                            <Button label="Download SHP" icon="pi pi-download" onClick={() => handleDownload('propriedade', 'shp')} />
                            <Button label="Download KML" icon="pi pi-download" onClick={() => handleDownload('propriedade', 'kml')} />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                        <h4>Lotes</h4>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', height: 100 }}>
                            <Button label="Download SHP" icon="pi pi-download" onClick={() => handleDownload('lotes', 'shp')} />
                            <Button label="Download KML" icon="pi pi-download" onClick={() => handleDownload('lotes', 'kml')} />
                        </div>
                    </div>
                </div>

            </div>
        </Dialog>
    );

    return (
        <div className='Info'>
            <Toast ref={toast} position='center' />
            <Toast ref={toastRef} />
            {downloadDialog}
            <Dialog
                header="Processando Relatório"
                visible={dialogVisivel}
                modal
                style={{ width: '50vw', minWidth: '350px' }}
                onHide={onHideDialog} // Chamado ao tentar fechar (ex: ESC, botão X se `closable` fosse true)
                closable={apiConcluida} // Só permite fechar após a API concluir (sucesso/erro)
                footer={dialogFooter}
            >
                <div className="p-fluid" style={{ padding: '1rem 0' }}>
                    <p style={{ marginBottom: '1rem', textAlign: 'center' }}>{mensagemLoading}</p>
                    {!erroProcessar &&
                        <>
                            {!apiConcluida && <p style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
                                Tempo decorrido: {segundos} segundos
                            </p>}
                            <ProgressBar
                                // value={progresso} 
                                // showValue={true} 
                                mode="indeterminate"
                                style={{ height: '20px' }} />
                        </>
                    }
                    {erroProcessar && <div style={{ textAlign: 'center' }}>
                        <FaRegTimesCircle size={50} color='#D22' />
                    </div>}
                    {!apiConcluida && progresso >= 99 && progresso < 100 && (
                        <p style={{ marginTop: '1rem', textAlign: 'center', fontSize: '0.9em', color: '#6c757d' }}>
                            Quase lá! Finalizando os últimos detalhes...
                        </p>
                    )}
                </div>
            </Dialog>
            {dialogProcessar}
            <ConfirmDialog />
            <CustomToolbar user={auth.user} titulo={propriedade.nome?.toUpperCase()} loading={loading} />

            <Dialog header={`Propriedade ${propriedade.nome}`} visible={showInfo} modal={false} style={{ width: '50vw' }} onHide={() => setShowInfo(false)}>

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                    <label htmlFor='municipio'>MUNICÍPIO</label>
                    <InputText id='municipio' value={propriedade.municipio?.nome ? propriedade.municipio.nome : municipio.nome.toUpperCase()} disabled style={{ marginBottom: 10 }} />

                    <label htmlFor='localidade'>LOCALIDADE</label>
                    <InputText id='localidade' value={propriedade.localidade?.toUpperCase()} disabled style={{ marginBottom: 10 }} />

                    <label htmlFor='acesso'>ACESSO</label>
                    <InputText id='acesso' value={propriedade.acesso?.toUpperCase()} disabled style={{ marginBottom: 10 }} />

                    <label htmlFor='proprietario'>PROPRIETÁRIO</label>
                    <InputText id='proprietario' value={propriedade.proprietario?.pessoa?.nome_razao.toUpperCase()} disabled style={{ marginBottom: 10 }} />

                    <label htmlFor='doc_matricula'>DOCUMENTO DE MATRÍCULA</label>
                    {propriedade.doc_matricula ? (
                        <Button icon="pi pi-file-pdf" label="Abrir Documento" onClick={() => window.open(propriedade.doc_matricula)} style={{ marginBottom: 10 }} />
                    ) : (
                        <InputText value="N/A" disabled style={{ marginBottom: 10 }} />
                    )}

                    <Button severity='danger' style={{ marginTop: 10, width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}
                    onClick={e => confirmRemove()} disabled={!auth.hasPermission('monitorabahia.delete_propriedade')}><FaTrash style={{ marginRight: 5 }} />REMOVER</Button>
                </div>

            </Dialog>


            <div id='map' ref={mapRef} style={{ zIndex: -1 }} />
            <Tooltip className="dark-tooltip" target=".dock-window .p-dock-action" my="center bottom-15" at="center top" showDelay={150} />
            <div className="dock-window" style={{ zIndex: 1 }}>
                <Dock model={items} position={'bottom'} />
            </div>
        </div >
    );
}


export default Propriedade;